import { ComponentView } from "binder";
import { getAsBoolean } from "../../../utilities";
import { BooleanFilterViewModel } from "./booleanFilter-viewModel"

export class BooleanFilterView extends ComponentView<BooleanFilterViewModel>{
    GetViewUniqueId(): string {
        return "V-86F1E39F-E93B-4B7B-A899-646D8202FFFB"
    }
    loadHtml(): string {
        let element = require('./booleanFilter.html').default;
        let style = require('./booleanFilter.less');
        return element;
    }
    constructor() {
       super();
    }

    public set isActive(v: boolean) { this._isActive =getAsBoolean(v); } public get isActive(): boolean { return this._isActive;} private _isActive: boolean;
    public set value(v: boolean) { this._value =getAsBoolean(v); } public get value(): boolean { return this._value;} private _value: boolean;
    public set text(v: string) { this._text = v; } public get text(): string { return this._text;} private _text: string;
    public set needsReverse(v: boolean) { this._needsReverse = v; } public get needsReverse(): boolean { return this._needsReverse;} private _needsReverse: boolean;
    public set reverseText(v: string) { this._reverseText = v; } public get reverseText(): string { return this._reverseText;} private _reverseText: string;

    apply(){
        this.isActive = true;
        this.dataContext.apply();
    }
    removeFilter(){
        this.isActive = false;
        this.dataContext.apply();
    }
}
